import {
    AccountLabel,
    OtherCategory,
} from "@/entities/DataAssociation/Account.model";
import clsx from "clsx";
import { useCallback, useMemo } from "react";
import { ACCOUNT_LIST } from "../../constants/labeling.constants";
import { useRowSelection } from "../../hooks/useRowSelection";
import { LabelList } from "../LabelList";
import { AccountHintType } from "@/entities/DataAssociation/Draft.model";

export function PseudoAccountList({
    selectedCategory,
}: {
    selectedCategory: OtherCategory;
}) {
    const { onAccountSelection } = useRowSelection();

    const labels = useMemo(() => {
        return Object.values(ACCOUNT_LIST).filter(
            (account) => account.category === selectedCategory,
        );
    }, [selectedCategory]);

    const onLabelSelection = useCallback(
        (label: AccountLabel) => {
            onAccountSelection({
                type: AccountHintType.NEW,
                accountName: ACCOUNT_LIST[label].name,
                label: label,
            });
        },
        [onAccountSelection, selectedCategory],
    );

    if (!labels) return null;

    return (
        <div className={clsx("flex flex-col pb-8")}>
            <LabelList labels={labels} onLabelSelection={onLabelSelection} />
        </div>
    );
}
